import { useState, useCallback, useMemo } from 'react'
import { useNavigate } from "react-router-dom"

export const useFallBack = () => {
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)
    const [redirect, setRedirect] = useState("/central-agendamento")

    const defaultConfirm = useCallback(() => {
        navigate(redirect, { replace: true })
    }, [navigate, redirect])

    const createModalState = useCallback((state = {}) => {
        const { redirect: stateRedirect, ...prevState } = state

        if (stateRedirect) {
            setRedirect(stateRedirect)
        }

        return {
            title: prevState?.title || "Central de Agendamento",
            description: (
                <div style={{margin: '3px 0'}}>
                    {prevState?.description || "Favor entrar em contato com a Central."}
                </div>
            ),
            labelConfirm: prevState?.labelConfirm || "Ok",
            handleConfirm: prevState?.onConfirm || defaultConfirm,
            handleClose: prevState?.handleClose,
            disableCancel: prevState?.disableCancel,
            disableEscapeKeyDown: prevState?.disableEscapeKeyDown
        }
    }, [defaultConfirm])

    const [fallback, setFallBack] = useState(() => createModalState())

    const transformFallback = useCallback((state) => {
        setFallBack(createModalState(state))
    }, [createModalState])

    const modal = useMemo(() => fallback, [fallback])

    return { 
        modal,
        setModal: transformFallback,
        isOpen: open,
        setOpen,
        setRedirect
    }
}
